<div class="containeer-fluid">
    <div class="row">
        <div class="col-auto g-0  d-flex align-items-start">

            <app-uiform-side-menu [uiformId]="uiformId" targetId="edit" [usecaseId]="usecaseId" [appId]="attributeId">
            </app-uiform-side-menu> 
        </div>

        <div class="col-11">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                          <div class="d-flex justify-content-between align-items-center">
                            <h4 class="card-title"> {{form.data['title'] }} 
                                
                             </h4>
                             <div class="h4">                            
                              <a
                              ngbTooltip="{{ form.data['description'] }}"
                              container="body"                                            
                              tooltipClass="custom-tooltip"
                              class="tooltip-icon ms-1"
                              title="Tooltip"
                               [routerLink]="['/usecaseHelp/'+uiformId]"
                            >
                              <i class="fa fa-info-circle"></i>
                            </a>                          
                               </div>
                          </div>  
                            <h6 class="text-mute "> {{form.data['subtitle'] }}</h6>
                        </div>
                 
                        <div class="card-body" #content>

                            <a *ngIf="form.data?.buttons?.['new']"
                                class="btn btn-outline-secondary btn-sm radius-30 mb-2" title="Add New"
                                (click)="fieldButtonSubmit('new')"> <i class="fa fa-plus"></i>New</a>

                            <p *ngIf="form['error'] == false && entryform['message']">
                                 <app-ncs-alert [message]="entryform['message']" /> 
                            </p>
                            <p *ngIf="form['error'] == true && entryform['message']">
                                <app-ncs-alert [message]="entryform['message']" alertClass="danger" type="danger" />
                            </p>

                            <ng-container *ngFor="let uni of usecaseSchema.unique">
                                <app-ncs-alert *ngIf="isArray(uni) && getInputError(uni.join('_')) !== ''"
                                    [message]="getInputError(uni.join('_'))" showAlert="true" type="danger" />
                            </ng-container>
                            
                            <div *ngIf="form.data['id'] > 0">
                                <div *ngFor="let field of form.data['fields']; let i = index"
                                    class="col-{{form.data.cols}}">
                                    <ng-container *ngIf="getAttributeById(field.id) as e">
                                        <label for="title" class="form-label" *ngIf="e['type']!=='file'">{{e.label}}   
                                            <span *ngIf="e['required']==1">*</span> 
                                            </label>
                                        <label for="title" class="form-label"
                                            *ngIf="e['type']==='file' && entryform.data['id'] > 0 ">{{e.label}}   
                                            <span *ngIf="e['required']==1">*</span>
                                           </label>
                                        <div *ngIf="e['refKey']!=1 && e['type']!=='list'  && e['type']!=='file' && e['type']!=='map'  && e['type']!=='textarea'"
                                            class="mb-2">

                                            <div *ngIf="field['rows'] > 0 || field['cols'] > 0" class="input-tooltip-container">
                                                <textarea class="form-control"  [rows]="field['rows']" 
                                                    cols="{{ field['cols'] }}" class="form-control"
                                                    [(ngModel)]="entryform.data[e.code]" id="{{e.code}}"
                                                    name="{{e.code}}" placeholder="{{e.label}}">
                                                    </textarea>
                                                    <span ncsTooltip [title]="getDescription(e)">
                                                      <i class="fa fa-info-circle fs-4 ms-1" style="color: #008cff;"></i>
                                                  </span>
                                            </div>

                                            <!-- If neither row nor col > 0, show this alternative text area -->
                                            <div *ngIf="!(field['rows'] > 0 || field['cols'] > 0)"  class="input-tooltip-container">
                                                <input required="{{e['required']==1}}" [type]="getInputType(e.type)" readonly
                                                    [(ngModel)]="entryform.data[e.code]"
                                                    class="form-control form-control-sm" id="{{e.code}}"
                                                    name="{{e.code}}" placeholder="{{e.label}}" >  
                                                   
                                                    <span ncsTooltip [title]="getDescription(e)">
                                                      <i class="fa fa-info-circle fs-4 ms-1" style="color: #008cff;"></i>
                                                  </span>
                                            </div>
                                        </div>
                                 
                                        <div *ngIf="e['refKey']==1" class="mb-2  input-tooltip-container" >
                                            <select required="{{e['required']==1}}" [(ngModel)]="entryform.data[e.code]" readonly
                                                (change)="onChange(e,$event)" class="form-control form-select-sm"
                                                id="{{e.code}}" name="{{e.code}}">
                                                <option value="0">--Select-- {{entryform.data[e.code]}}</option>
                                                <option *ngFor="let c of getPrimaryUsecase(e)" value="{{c['id']}}">
                                                    {{c['_val']}}</option>
                                            </select>
                                            <span ncsTooltip [title]="getDescription(e)">
                                              <i class="fa fa-info-circle fs-4 ms-1" style="color: #008cff;"></i>
                                          </span>
                                        </div>

                                        <!-- Text Area List  -->
                                    <div *ngIf="e['type']==='textarea'" class="mb-2 input-tooltip-container">
                                        <textarea required="{{e['required']==1}}" [(ngModel)]="entryform.data[e.code]" readonly
                                            class="form-control form-control-sm" id="{{e.code}}" name="{{e.code}}"
                                            placeholder="{{e.label}}" name="{{e.code}}"> </textarea>
                                            <span ncsTooltip [title]="getDescription(e)">
                                              <i class="fa fa-info-circle fs-4 ms-1" style="color: #008cff;"></i>
                                          </span>
                                    </div>

                                        <!-- DropDown List  -->
                                        <div *ngIf="e['type']==='list'" class="mb-2 input-tooltip-container">
                                            <select required="{{e['required']==1}}" [(ngModel)]="entryform.data[e.code]" readonly
                                                (change)="onChange(e,$event)" class="form-control form-select-sm"
                                                id="{{e.code}}" name="{{e.code}}">
                                                <option value="0">--Select-- {{e.code}}</option>
                                                <option *ngFor="let c of e['values']" value="{{c}}">{{c}}
                                                </option>
                                            </select>
                                            <span ncsTooltip [title]="getDescription(e)">
                                              <i class="fa fa-info-circle fs-4 ms-1" style="color: #008cff;"></i>
                                          </span>
                                        </div>

                                        <!-- Image File  -->
                                        <div *ngIf="e['type']==='file' && entryform.data['id'] > 0" class="mb-2 input-tooltip-container">                                           
                                            <input class="form-control" id="form.data[e.code]" #file type="file" readonly
                                                accept="image/*" name="form.data[e.code]"
                                                (change)="file.files && onFileChanged($event,e.code,entryform.data[e.code])" />

                                                <span ncsTooltip [title]="getDescription(e)">
                                                  <i class="fa fa-info-circle fs-4 ms-1" style="color: #008cff;"></i>
                                              </span>
                                        </div>
                                        
                            <!-- Image Preview -->
                            <div  class="mb-4" *ngIf=" e['type']==='file' && entryform.data['id'] > 0">
                                <img [src]="imagePreview == null ? getDocThumbnailImage(entryform.data[e.code]) : imagePreview"
                                    alt="Image Preview" class="img-thumbnail"
                                    style="max-width: 200px; max-height: 200px;">
                            </div>
                                        
                                        <!-- DropDown List  -->
                                        <div *ngIf="e['type']==='map'" class="mb-2 input-tooltip-container">
                                            <select required="{{e['required']==1}}" [(ngModel)]="entryform.data[e.code]" readonly
                                                (change)="onChange(e,$event)" class="form-control form-select-sm"
                                                id="{{e.code}}" name="{{e.code}}">
                                                <option value="0">--Select-- {{e.code}}</option>
                                                <option *ngFor="let c of e['values']" value="{{c.key}}">
                                                    {{c.value}}
                                                </option>
                                            </select>
                                            <span ncsTooltip [title]="getDescription(e)">
                                              <i class="fa fa-info-circle fs-4 ms-1" style="color: #008cff;"></i>
                                          </span>
                                        </div>
                                        <div class="form-text text-danger">{{getInputError(e.code)}}</div>
                                    </ng-container>
                                </div>
                            </div>
                            <div *ngIf="form.data['id'] == 0 ">
                                not field for edit
                            </div>

                            <div class="text-start" *ngIf="form.data['id'] > 0">
                              <div class="btn-group" *ngIf="form.data.readOnly !='true'">
                                <button *ngFor="let btn of form.data.buttons" type="button" class="btn btn-sm btn-outline-primary ms-2"  title="{{ getButtonLabel(btn['name']) }}"
                                    (click)="fieldButtonSubmit(btn['name'])">
                                    <i [class]="getButtonIcon(btn['name'])"></i> {{ getButtonLabel(btn['name']) }}
                                </button>
                            </div>
                             </div>
                         </div>
                        <!-- Card Footer with Button Group -->

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>


<!-- Modal -->
<div class="modal fade" id="shareFormModal" tabindex="-1" aria-labelledby="shareModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="shareModalLabel">Share Form</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" title="Close" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form #uiForm="ngForm">
            <p>
                <form-error [form]="shareform"></form-error>
            </p>
            <div class="mb-3">
              <label for="name" class="form-label">Name</label>
              <input 
                required 
                type="text" 
                [(ngModel)]="shareform.data['name']"
                class="form-control form-control-sm" 
                id="name" 
                name="name" 
                placeholder="Enter Name">
            </div>
  
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input 
                required 
                type="email" 
                [(ngModel)]="shareform.data['email']"
                class="form-control form-control-sm" 
                id="email"  
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                name="email" 
                placeholder="Enter Email">
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button 
            type="button" 
            class="btn btn-primary"  
            (click)="sharePdf()"  
            title="Send"
            [disabled]="!uiForm.valid">
            Send
          </button>
          <button 
            type="button" 
            class="btn btn-secondary" 
            title="Close" 
            data-bs-dismiss="modal">
            Close
          </button>         
        </div>
      </div>
    </div>
  </div>
  


